import { type FC } from 'react';
import { Button, Text } from '@chakra-ui/react';
import { translate } from '../../../../constants/translation';
import { ReactComponent as SeeSomethingWrongIcon } from '../../../../assets/svg/SeeSomethingWrongIcon.svg';

interface Props {
  onWhatWentWrongClick: () => void;
}

export const WhatWentWrongButton: FC<Props> = ({ onWhatWentWrongClick }) => {
  return (
    <Button
      variant="secondary"
      leftIcon={<SeeSomethingWrongIcon />}
      onClick={e => {
        onWhatWentWrongClick();
        e.stopPropagation();
      }}
    >
      <Text>{translate('WHAT_WENT_WRONG')}</Text>
    </Button>
  );
};
